// extracted by mini-css-extract-plugin
export default {"disclaimer":"disclaimer_disclaimer__NWkpi"};